module.exports = __webpack_public_path__ + "static/media/develop.65ea7962.jpg";